/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SuggestExclusionResult = {
  /**
   * How match_value is interpreted (exact, regex, rule_id, source, entity_type).
   */
  matchType: string;
  /**
   * The value matched against findings, interpreted per match_type.
   */
  matchValue: string;
  /**
   * Only apply within this rule_id. Empty means any.
   */
  ruleIdFilter?: string | undefined;
  /**
   * Only apply within this source. Empty means any.
   */
  sourceFilter?: string | undefined;
};

/** @internal */
export const SuggestExclusionResult$inboundSchema: z.ZodMiniType<
  SuggestExclusionResult,
  unknown
> = z.pipe(
  z.object({
    match_type: z.string(),
    match_value: z.string(),
    rule_id_filter: z.optional(z.string()),
    source_filter: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "match_type": "matchType",
      "match_value": "matchValue",
      "rule_id_filter": "ruleIdFilter",
      "source_filter": "sourceFilter",
    });
  }),
);

export function suggestExclusionResultFromJSON(
  jsonString: string,
): SafeParseResult<SuggestExclusionResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SuggestExclusionResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SuggestExclusionResult' from JSON`,
  );
}
